import React from 'react'
import QuestionFormPage from './QuestionFormPage'

const AddQuestion = () => {
  return (
    <div><QuestionFormPage isAdd={"Add"}/></div>
  )
}

export default AddQuestion